import { createDateFromComponents, validateDateTimeRange } from "./dateUtils";

export function validateViewingPeriodFields(
  startViewingDate: string | null,
  startViewingTime: string,
  endViewingDate: string | null,
  endViewingTime: string,
  t: (key: string) => string,
): string {
  // Validate viewing period fields are not empty
  if (
    !startViewingDate ||
    !startViewingTime ||
    !endViewingDate ||
    !endViewingTime
  ) {
    return t("editPackage.validation.dateAndTime.required");
  }

  const isViewingPeriodValid = validateDateTimeRange(
    startViewingDate,
    startViewingTime,
    endViewingDate,
    endViewingTime,
  );

  if (!isViewingPeriodValid) {
    return t("newPackage.validation.dateAndTime.endDateError");
  }

  return "";
}

export function validateCampaignInterviewPeriod(
  campaign: {
    startInterviewDate: string | null;
    startInterviewTime: string;
    endInterviewDate: string | null;
    endInterviewTime: string;
  },
  startViewingDate: string | null,
  startViewingTime: string,
  endViewingDate: string | null,
  endViewingTime: string,
  t: (key: string) => string,
): string {
  // All interview period fields are required
  if (
    !campaign.startInterviewDate ||
    !campaign.startInterviewTime ||
    !campaign.endInterviewDate ||
    !campaign.endInterviewTime
  ) {
    return t("editPackage.validation.dateAndTime.required");
  }

  const isInterviewPeriodValid = validateDateTimeRange(
    campaign.startInterviewDate,
    campaign.startInterviewTime,
    campaign.endInterviewDate,
    campaign.endInterviewTime,
  );

  if (!isInterviewPeriodValid) {
    return t("newPackage.validation.dateAndTime.endDateError");
  }

  const startViewingDateTime = createDateFromComponents(
    startViewingDate,
    startViewingTime,
  );
  const endViewingDateTime = createDateFromComponents(
    endViewingDate,
    endViewingTime,
  );
  const startInterviewDateTime = createDateFromComponents(
    campaign.startInterviewDate,
    campaign.startInterviewTime,
  );
  const endInterviewDateTime = createDateFromComponents(
    campaign.endInterviewDate,
    campaign.endInterviewTime,
  );

  if (
    startViewingDateTime > startInterviewDateTime ||
    endViewingDateTime < endInterviewDateTime
  ) {
    return t("newPackage.validation.dateAndTime.interviewPeriodError");
  }

  return "";
}
